import { useTypedQuery } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Dealer } from "models";
import type { PlanitEstablishment } from "modules/DealersDashboard/queryKeys";

const formatEstablishmentOptions = (establishments: PlanitEstablishment[]) =>
  establishments.map(({ Id, Name, DealerLocationID }) => ({ key: Id, value: Id, text: Name, disabled: Boolean(DealerLocationID) }));

export const usePlanitEstablishmentsQuery = (dealer?: Dealer) =>
  useTypedQuery({
    queryKey: DealersDashboardQueryKeys.planitEstablishments(dealer?.id),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.establishments,
    select: formatEstablishmentOptions,
    enabled: Boolean(dealer?.planit_planning_enabled)
  });
